<div class="d-lg-block d-none">
  <fgb-banner [title]="'rewards.marketplace.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  <div class="container mb-4">
    <div class="font-size-12 description font-heading fw-bold text-center border border-disabled py-3 border-rounded bg-white">
      {{ 'rewards.sales.info' | translate }}
    </div>
  </div>
  <div class="container">
    <fgbcl-marketplace-list
      [isList]="true"
      [marketplaceItemView]="true"
      [marketplaceItemTypes]="[0, 1, 2, 4, 5]"
      [defaultSort]="0"
    ></fgbcl-marketplace-list>
  </div>
</div>
